export const VIRAL_CONTENT_STATE_STATUSES = {
  EMPTY: 'EMPTY',
  PENDING: 'PENDING',
  DONE: 'DONE',
  ERROR: 'ERROR',
};

export const VIRAL_CLIP_RESOLVE_TIME = 3000;
